import axios from 'axios';
import UTILS from './commons';
export class ApiClient{
    axiosInstance;
    constructor(bearerToken = null, baseUrl = null){
       this.axiosInstance = axios.create({
           baseURL: baseUrl || UTILS.BASE_URL,
           headers: {
               'Content-Type': 'application/json',
               'Authorization': bearerToken ? `Bearer ${bearerToken}` : '',
           },
       });
       
    }

    signIn(email, password){
        return this.axiosInstance.post('/auth/signin', { email, password });
    }

    signUp(userData){
        return this.axiosInstance.post('/auth/signup', userData);
    }

    createUser(userData){
        return this.axiosInstance.post('/auth/create', userData);
    }

    getUserProfile(userId){
        return this.axiosInstance.get(`/auth/${userId}`);
    }
    get(endpoint, params = {}){
        return this.axiosInstance.get(endpoint, params);
    }
    post(endpoint, data){
        return this.axiosInstance.post(endpoint, data);
    }
    patch(endpoint, data){
        return this.axiosInstance.patch(endpoint, data);
    }
    delete(endpoint){
        return this.axiosInstance.delete(endpoint);
    }
}